import React from 'react'
import PropTypes from 'prop-types'
import { startCase } from 'lodash'

import Styles from './index.scss'

const SearchBox = props => (
  <div className="pull-left">
    <form
      name="filter-form"
      onSubmit={props.submitFilters}
      style={{ display: 'inline-table' }}
    >
      <div className={`${Styles['search-box']} form-group`}>
        <strong>FILTER BY:</strong>
      </div>
      <div className={`${Styles['search-box']} form-group`}>
        <div className={`search-bar ${Styles.addPadding}`}>
          <input
            className={`${Styles.searchBar} form-control`}
            name="searchProfileField"
            type="text"
            placeholder="Project Name / Brand / Project manager"
            onChange={e => props.onInputChange(e)}
            value={props.searchProjectBrand}
          />
        </div>
      </div>
      <div className={`${Styles['search-box']} form-group`}>
        <div className="input-group input-group-md">
          <select
            className="form-control"
            id="country"
            onChange={props.handleSelectedCountry()}
            value={props.selectedCountry}
          >
            <option value="">All Country</option>
            {props.selectionsCountry.map(option => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className={`${Styles['search-box']} form-group`}>
        <div className="input-group input-group-md">
          <select
            className={`${Styles['search-category']} form-control`}
            onChange={props.handleSelectedProjectStatus()}
            name="status"
            value={props.selectedProjectStatus}
          >
            <option value="">All Project Status</option>
            {props.orderStatus.map((status, index) => (
              <option key={status} value={index}>
                {startCase(status)}
              </option>
            ))}
          </select>
        </div>
      </div>
    </form>

    <form
      name="filter-form"
      onSubmit={props.submitFilters}
      style={{ display: 'inline-table' }}
    >
      <div className={`${Styles['search-box']} ${Styles['sort-by']} form-group`}>
        <strong>SORT BY:</strong>
      </div>
      <div className={`${Styles['search-box']} form-group`}>
        <div className="input-group input-group-md">
          <select
            className="form-control"
            id="sortby"
            onChange={props.handleSelectedSortBy()}
            value={props.sortBy}
          >
            <option key="updatedAt" value="updatedAt">
              Updated At
            </option>
            <option key="createdAt" value="createdAt">
              Created At
            </option>
            ))
          </select>
        </div>
      </div>
      <div className={`${Styles['search-box']} ${Styles['organic-projects']} form-group`}>
        <input
          name="isOrganic"
          type="checkbox"
          checked={props.isOrganicOnly}
          onChange={props.checkBoxFilter}
        />
        &nbsp;&nbsp;Organic Projects Only
      </div>

      <div className={`${Styles['search-box']} ${Styles['organic-projects']} form-group`}>
        <input
          name="isManaged"
          type="checkbox"
          checked={props.isManagedOnly}
          onChange={props.checkBoxFilter}
        />
        &nbsp;&nbsp;Managed Projects Only
      </div>
    </form>
  </div>
)

SearchBox.propTypes = {
  orderStatus: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectionsCountry: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectedProjectStatus: PropTypes.string.isRequired,
  searchProjectBrand: PropTypes.string.isRequired,
  selectedCountry: PropTypes.string.isRequired,
  sortBy: PropTypes.string.isRequired,
  handleSelectedProjectStatus: PropTypes.func.isRequired,
  handleSelectedSortBy: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  submitFilters: PropTypes.func.isRequired,
  handleSelectedCountry: PropTypes.func.isRequired,
  isOrganicOnly: PropTypes.bool.isRequired,
  checkBoxFilter: PropTypes.func.isRequired,
  isManagedOnly: PropTypes.bool.isRequired,
}

export default SearchBox
